import React, { Component } from "react";
import { Link } from "react-router-dom";
import AuthService from "../../utils/auth.service";
import MessageModal from "../../components/Message";
import Loading from "../../components/Loading";
//import Const from "../../utils/consts";
import ApiPagarmeCustomer from "../../utils/api.pagarme.customer";
import ApiRateio from "../../utils/api.rateio";
import ApiDeposit from "../../utils/api.deposit";

const valid = require('card-validator');

class PaymentPage extends Component {
  constructor(props) {
    super(props);

    let company_code = localStorage.getItem('company_code');

    this.doDepositV1 = this.doDepositV1.bind(this);
    
    this.doGatewayDeposit = this.doGatewayDeposit.bind(this);
    
    this.getPagarMeErrorsV1 = this.getPagarMeErrorsV1.bind(this);
    this.handleCardChange = this.handleCardChange.bind(this);
    this.handleElementChange = this.handleElementChange.bind(this);
    this.toggleAlert = this.toggleAlert.bind(this);
    this.blockActions = this.blockActions.bind(this);
    this.cardMask = this.cardMask.bind(this);
    this.expirationMonthMask = this.expirationMonthMask.bind(this);
    this.expirationYearMask = this.expirationYearMask.bind(this);
    this.CPFMask = this.CPFMask.bind(this);
    this.CVVMask = this.CVVMask.bind(this);
    this.PhoneMask = this.PhoneMask.bind(this);
    //this.cardIsValid = this.cardIsValid.bind(this);
    this.replaceAll = this.replaceAll.bind(this);
    
    this.state = {
      loading: false,
      st_company_code: company_code,
      profile: AuthService.profileUser,
      
      modal: {
        isOpen: false,
        title: '',
        message: '',
      },
      assetMessage: '',
	    
      
      st_amount: '',
      st_card_number: '',
      st_holder_name: '',
      st_expiration_month: '',
      st_expiration_year: '',
      st_cvv: '',
      st_CPF: '',
	    st_phone_number: '',
	    st_street_address: '',
      st_neiborhood: '',
      st_city: '',
      st_state: '',
      st_country: '',
      st_ZIP: '',
      st_first_name: '',
      st_last_name: '',
	    
      depositDisabled: false
    };

    document.addEventListener("profileLoaded", data => {
      if (data.detail && data.detail.profile) {
        const profile = data.detail.profile;
        this.setState(...this.state, { profile: profile })
      }
    });
  }

  pagarme = require('pagarme');

  selectedCard = this.props.location.state; // Came from CreditCardPage
	
	payment_gateway = this.props.location.gateway;

  brands = {
    visa: '/assets/images/bandeira_visa_cor.svg',
    mastercard: '/assets/images/bandeira_mastercard_cor.svg',
    american: '/assets/images/bandeira_american_cor.svg',
    elo: '/assets/images/bandeira_elo_cor.svg',
  };
  
  componentDidMount() {
  	//console.log('Payment page Did Mount')
  }
	
  resetCardState() {
    this.setState({
      assetMessage: null,
      st_amount: '',
      st_card_number: null,
      st_expiration_month: null,
      st_expiration_year: null,
	    st_holder_name: null,
	    st_cvv: null,
	    st_CPF: null,
	    st_phone_number: null,
	    st_street_address: null,
	    st_neiborhood: null,
	    st_city: null,
	    st_state: null,
	    st_country: null,
	    st_ZIP: null
    })
  }

  handleCardChange(event) {
    this.setState(...this.state, { st_card_number: event.target.value });

    var numberValidation = valid.number(event.target.value);  // Pagarme??? kkkk

    if (!numberValidation.isPotentiallyValid) {
      console.log("Número inválido: ", numberValidation);
      // renderInvalidCardNumber();
    }

    if (numberValidation.card) {
      console.log(numberValidation.card.type); // 'visa'
    }
  }

  handleElementChange(event) {
    const el = event.target.name;
    const val = event.target.value;
    this.setState({ [el]: val });
  }

  cardMask(event) {
    const el = event.target;
    let val = el.value;
    
    //this.replaceAll(val,'-','');
    let len = val.length;
    
    if ((event.key !== "Backspace") && ((event.key !== "Tab") || ((event.key !== "Tab") && (event.shiftKey)) )) {
    	
    	const inp = String.fromCharCode(event.keyCode);
	    if (/[0-9]/.test(inp)) {
		
		    const isNumber = isFinite(event.key);
		
		    if (isNumber) {
			    if (len === 15) { val = [val.slice(0, 14), '-', val.slice(14, len)].join(''); } else {
				    if (len === 10) {val = [val.slice(0, 9), '-', val.slice(9, len)].join(''); } else {
					    if (len === 5) {val = [val.slice(0, 4), '-', val.slice(4, len)].join('') }
				    }
			    }
		    }
	    } else { val = val.slice(0,len-1) }
    }
    
    this.setState({st_card_number: val});
    
  }
	
  CPFMask(event) {
    const el = event.target;
    let val = el.value;
    let len = val.length;
    //var inp = String.fromCharCode(event.keyCode);
		//if (/[a-zA-Z0-9-_ ]/.test(inp))
     // alert("input was a letter, number, hyphen, underscore or space");
    const isNumber = isFinite(event.key);
    
    if ((event.key !== "Backspace") && ((event.key !== "Tab") || ((event.key !== "Tab") && (event.shiftKey)) )) {
    
	    if (isNumber) {
		    if (len === 12) { val = [val.slice(0, 11), '-', val.slice(11, len)].join(''); } else {
			    if (len === 8) {val = [val.slice(0, 7), '.', val.slice(7, len)].join(''); } else {
				    if (len === 4) {val = [val.slice(0, 3), '.', val.slice(3, len)].join('') }
			    }
		    }
	    } else { val = val.slice(0, len - 1) }
    }
    
    this.setState({st_CPF: val});
    
  }
  
  CVVMask(event) {
    const el = event.target;
    let val = el.value;
    let len = val.length;
    
    if ((event.key !== "Backspace") && ((event.key !== "Tab") || ((event.key !== "Tab") && (event.shiftKey)) )) {
    
	    const inp = String.fromCharCode(event.keyCode);
	
	    if (!/[0-9]/.test(inp)) { val = val.slice(0, len - 1) }
    }
	   
    this.setState({st_cvv: val});
    
  }
  
  PhoneMask(event) {
    const el = event.target;
    let val = el.value;
    let len = val.length;
    const isNumber = isFinite(event.key);
    
    if (isNumber) {
		    if (len === 10) { val = [val.slice(0, 9), '-', val.slice(9, len)].join(''); }
		    else {
			    if (len === 3) {
			    	
			    	const p = val.slice(0,1);
			    	
			    	if (p === '(') {
			    		
			    		val = val.slice(1, len)
			    		
				    }
				    
			    	val = ['(', val.slice(0, 2), ')', val.slice(2, len)].join(''); }
		    }
    } else { val = val.slice(0,len-1) }
    
    this.setState({st_phone_number: val});
    
  }

  expirationMonthMask(event) {
    const el = event.target;
    let val = el.value;
    let len = val.length;
	  
    if ((event.key !== "Backspace") && ((event.key !== "Tab") || ((event.key !== "Tab") && (event.shiftKey)) )) {
    	
    	const inp = String.fromCharCode(event.keyCode);
	    if (/[0-9]/.test(inp)) {
	    	
	    	const isNumber = isFinite(event.key);
	      if (isNumber) {
			    if ((len === 2) && (Number(val) < 1 || Number(val) > 12)) { val = '';}
		    }
		    
	    } else { val = val.slice(0, len - 1) }
	    
	    this.setState({st_expiration_month: val});
    }
  }
  
  expirationYearMask(event) {
    const el = event.target;
    let val = el.value;
    let len = val.length;
	  
    if ((event.key !== "Backspace") && ((event.key !== "Tab") || ((event.key !== "Tab") && (event.shiftKey)) )) {
    	
    	const inp = String.fromCharCode(event.keyCode);
	    if (/[0-9]/.test(inp)) {
	    	
	    	const isNumber = isFinite(event.key);
	      if (isNumber) {
			    if ((len === 2) && (Number(val) < 19 || Number(val) > 50)) { val = '';}
		    }
		    
	    } else { val = val.slice(0, len - 1) }
	    this.setState({st_expiration_year: val});
    }
  }
  
  cardIsValid() {  // Dot not bind. Why?
	  
  	let card_Ok = (this.state.st_card_number && (this.state.st_card_number.length >= 15))
                && (this.state.st_expiration_year && Number(this.state.st_expiration_year) >= 19)
                && (this.state.st_expiration_month && Number(this.state.st_expiration_month) <= 12)
                && (this.state.st_cvv && Number(this.state.st_cvv.length) >= 3)
                && (this.state.st_cvv && Number(this.state.st_cvv.length) <= 4)
	              && (this.state.st_holder_name && this.state.st_holder_name.length > 3);
	  
	  return card_Ok //&& year_Ok && month_Ok
	  
  }

  replaceAll(target, search, replacement) {
    return target.split(search).join(replacement);
  }

  toggleAlert() {
    this.setState(...this.state, {
      modal: { isOpen: !this.state.modal.isOpen }
    });
  }
  
  blockActions(block) {
    this.setState({
      loading: block,
      depositDisabled: block,
    });
  }
  
  doGatewayDeposit(gateway, efective) {
  	
  	switch (gateway) {
  		
		  case 'PagarMe': {
		  	this.doDepositV1();
		  	break;
		  }
		  default:
		  case 'RateioDigital': {
		  	this.doDepositV2(efective);
		  	break;
		  }
	  }
  }
	
  //#region PagarMe
	
  createCardObjectV1(customerId) {
    let card = {};

    if (!this.selectedCard) {
      card.card_number = this.replaceAll(this.state.st_card_number, '-', '');
      card.card_cvv = this.state.card_cvv;
    } else {
      card.card_first_digits = ''; //this.selectedCard.first_digits;
      card.card_last_digits = this.selectedCard.last_digits;
      card.id = this.selectedCard.id;
    }

    card.customer_id = customerId;
    card.card_holder_name = this.selectedCard ? this.selectedCard.holder_name : this.state.st_holder_name;
    //card.card_expiration_month = this.selectedCard ? this.selectedCard.expiration_month : this.state.st_expiration_month;
    //card.card_expiration_year = this.selectedCard ? this.selectedCard.expiration_year : this.state.st_expiration_year;
		card.card_expiration_date =
			this.selectedCard ? this.selectedCard.expiration_month + this.selectedCard.expiration_year
			: this.state.st_expiration_month + this.state.st_expiration_year;
    return card;
  }

  createCardV1(customerId) {
    const card = this.createCardObjectV1(customerId);
    if (card.id) {
      return new Promise((resolve, reject) => {
        resolve(card);
      });
    }
    return this.pagarme.client.connect({ api_key: 'ak_test_8VShIWqrXoOPGNpEi3DnGTum9WHAqz' })
      .then(client => {
        return client.cards.create(card).then(card => {
          return card;
        });
      });
  }

  getCustomerV1() {
    return ApiPagarmeCustomer.get('ak_test_8VShIWqrXoOPGNpEi3DnGTum9WHAqz', this.state.profile.email)
	    .then((response) => {
	      const hits = response.data.hits.hits;
	      const customer = response.data ? hits.length ? hits[0] : null : null;
	      return customer;
    });
  }

  createCustomerObjectV1() {
    const customer = {
      name: this.state.profile.name,
      email: this.state.profile.email,
      external_id: this.state.profile.uid,
      type: 'individual',
      country: 'br',
      phone_numbers: ['+5531999999999'],
      documents: [
        {
          "type": "cpf",
          "number": "11111111111"
        }
      ],
    };

    return customer;
  }

  createCustomerV1() {
    return this.getCustomerV1().then(customerRemote => {
      if (customerRemote) {
        return new Promise((resolve, reject) => {
          resolve(customerRemote._source);
        });
      }
      const customerObj = this.createCustomerObjectV1();
      return this.pagarme.client.connect({ api_key: 'ak_test_8VShIWqrXoOPGNpEi3DnGTum9WHAqz' })
        .then(client => client.customers.create(customerObj))
        .then(customer => {
          return customer;
        });
    });
  }

  getPagarMeErrorsV1(error) {
    let answer = '';
    console.log(error);
    let errors = error.response.errors;
    for (let i = 0; i < errors.length; i++) {
      const e = errors[i];
      answer += `</br>- ${e.message}`;
    }
    return answer;
  }

  doDepositV1() {

    try {
      this.blockActions(true);

      let card = this.createCardObjectV1();

      // Somente valida cartões que não foram cadastrados.
      if (!this.selectedCard) {
        // pega os erros de validação nos campos do form e a bandeira do cartão
        var cardValidations = this.pagarme.validate({ card: card });

        //Então você pode verificar se algum campo não é válido
        if (!cardValidations.card.card_number) {
          this.setState({
            modal: {
              title: 'Oops!',
              message: 'Invalid card number',
              isOpen: true,
            }
          });
          this.blockActions(false);
        }
      }

      const trans = {
        amount: this.state.st_amount,
        metadata: {
          uid: this.state.profile.uid,
          company_code: this.state.st_company_code,
        },
        //postback_url: `${Const.api}webhook`,
      };

      this.createCustomerV1()
	      .then(customer => {
          this.createCardV1(customer.id)
		        .then(card => {
		          trans.card_id = card.id;
		          //Mas caso esteja tudo certo, você pode seguir o fluxo
		          ApiDeposit.post(trans)
			          .then(transaction => {
			            console.log(transaction);
			            this.resetCardState();
			            this.props.history.push({
			              pathname: '/profile/wallet',
			              state: {
			                showDepositSuccess: true,
			              }
			            });
		          })
		            .catch((error) => {
		              console.log(error);
		              this.setState({
		                modal: {
		                  title: 'Deposit error',
		                  message: this.getPagarMeErrorsV1(error),
		                  isOpen: true,
		                }
		              });
		              this.blockActions(false);
		          })
		            .finally(() => {
		              AuthService.refresh();
		          });
	        })
	          .catch((error) => {
	            console.log(error);
	            this.setState({
	              modal: {
	                title: 'Create card error',
	                message: this.getPagarMeErrorsV1(error),
	                isOpen: true,
	              }
	            });
	            this.blockActions(false);
	          });
      })
        .catch((error) => {
          console.log(error);
          this.setState({
            modal: {
              title: 'Customer error: ',
              message: this.getPagarMeErrorsV1(error),
              isOpen: true,
            }
          });
          this.blockActions(false);
        });
    } catch (error) {
      this.setState({
        modal: {
          title: 'Oops!',
          message: ' An networking error has occurred...',
          isOpen: true,
        }
      });
    }
  };
  
  //#endregion
	
	//#region RateioDigital
	
  createCardObjectV2(userId) {
    let card = {};
	  
    if (!this.selectedCard) {
      card.number = this.replaceAll(this.state.st_card_number, '-', '');
      card.security_code = this.state.st_cvv;
    } else {
      
      card.id = this.selectedCard.id;
      card.brand = this.selectedCard.brand;
	    
    }

    card.user_id = userId;
    card.holder_name = this.selectedCard ? this.selectedCard.holder_name : this.state.st_holder_name;
    card.expiration_month = this.selectedCard ? String(this.selectedCard.expiration_month) : this.state.st_expiration_month;
    card.expiration_year = this.selectedCard ? this.selectedCard.expiration_year : this.state.st_expiration_year;
    
    card.expiration_year = this.selectedCard ? String(Number(card.expiration_year) - 2000) : String(2000 + Number(card.expiration_year));
    
    // console.log('****createCardObject : ', card);

    return card;
  };
  
  getCardV2 = (userId, cardId) => {
  	// Trocar para Rateio
	  
    return ApiRateio.getCards(userId)
	    .then((response) => {
		    
      //console.log('Got Card response : ', response);
      
        const card_list = response.data.data;
        
        //console.log('Got Cards :', cards);
      
        //let card = card_list.length ? card_list[0] : null;
		    
		    const card = card_list.find(card => {
		    	return card.id === cardId
		    });
		    
		    //console.log('Yes!!!! Found???? :', card);
		    return card;
		    
    });
  };

  createCardV2 = (userId) => {
   
  	const cardObj = this.createCardObjectV2(userId);
  	
  	if (cardObj.id) {
  	
	    return this.getCardV2(userId, cardObj.id)
		    .then(cardRemote => {
		    
		    	//console.log('cardRemote: ', cardRemote);
		    	
		      return new Promise((resolve, reject) => {
		        resolve(cardRemote);
	      });
	    })
	  } else {
	    
	    //if gets here create
		  
		  //console.log('Vai criar novo card: ', cardObj);
		  
	    return ApiRateio.createCard( userId, cardObj )
		    .then(response => {
			    
			      let card = null;
        	
	          if (response && response.data.data) {
	            card = response.data.data;
		        }
			      
          return card;
      });
    }
    
  };

  getUserV2 = () => {
  	// Trocar para Rateio
    return ApiRateio.getUserList(this.state.profile.email).then((response) => {
      const user_list = response.data.data;
      const user = user_list ? user_list.length ? user_list[0] : null : null;
      
      //console.log('Get User V2 (deposit) return:', user);
      return user;
    });
  };

  createUserObjectV2 = () => {
    const user = {
      name: this.state.st_first_name,  //this.state.profile.name,
      last_name: this.state.st_last_name, //profile.name,
      cpf: this.state.st_CPF,
      doc: this.state.st_CPF, //"09499139010", //"16725674089",  //44014958027
      email: this.state.profile.email,
      description: "Winvite Client",
      phone_number: this.state.st_phone_number,
      //address_attributes: {
      // 	street_address: "fadfafafdasfd", //this.state.st_street_address,
				//complement: "adfadfadfadf",
				//additional_info: "afadfadfadf",
				//neighborhood: "asdfadfadfadf", //this.state.st_neiborhood,
				//city: this.state.st_city,
				//state: "MG", //this.state.st_state,
				//postal_code: "30320520", //this.state.st_ZIP,
				//country_code: this.state.st_country
      //}
    };

    return user;
  };

  createUserV2 = () => { // Docs - Create new user
    return this.getUserV2()
	    .then(userRemote => {
    	
    	//console.log('getUserV2 inside createUserV2 return userRemote: ', userRemote)
    	
      if (userRemote) {
        return new Promise((resolve, reject) => {
          resolve(userRemote);
        });
      }
      
      // if gets here does not exist --> Create
      const userObj = this.createUserObjectV2();
      
      //console.log('Vai criar novo user: ', userObj);
      
      return ApiRateio.createUser(userObj)
        
        .then(response => {
        	
        	//let user = null;
        	
        	//if (response && response.data.data) {
          let user = response.data.data;
	        //}
          return user;
      });
    });
  };

  getErrorsV2 = (error) => {
	  
  	let msg = 'Opps...'
  	
	  if (error.response && error.response.data && error.response.data.errors) {
  		error.response.data.errors.forEach(err => {
			  msg += err;
			  msg += "\r\n";
		  })
	  }
	  
	  if (error.message) {
  		msg += error.message;
	  }
	  
	  
    return msg;
    
  };

  doDepositV2(efective)  {

    try {
      this.blockActions(true);
	    
      if (!this.selectedCard) {
        // pega os erros de validação nos campos do form e a bandeira do cartão
        
	      // Validar cartao na Rateio
	      
          this.blockActions(false);
      }
      
      this.createUserV2()
	      .then(user => {
      	
	        //console.log('CreateUserV2 return:', user.id);
		      
	        this.createCardV2(user.id)
		        .then(card => {
		        	
		        	if (efective) {
				
				        const trans = {
				        	
				        	card_id: card.id,
					        amount_cents: Number(this.state.st_amount) * 100,
					        description: "Deposit Winvite.io",
					        payment_type: 'card',
					        metadata: {
						        uid: this.state.profile.uid,
						        company_code: this.state.st_company_code,
					        }
					        
				        };
				
				        console.log('Trans: ', trans);
				        ApiRateio.createNewPayment(user.id, trans)
					        .then(response => {
						        let transaction = response.data.data;
						        
						        if (transaction.attributes.status === 'succeeded') {
							
							        const transaction_obj = {
								
								        id: transaction.id, attributes: {
									        user_id: transaction.attributes.user_id,
									        card_id: transaction.attributes.card_id,
									        amount_cents: transaction.attributes.amount_cents,
									        fee_cents: transaction.attributes.fee_cents,
									        status: transaction.attributes.status,
									        created_at: transaction.attributes.created_at,
									        metadata: {
										        uid: transaction.attributes.metadata.uid,
										        company_code: transaction.attributes.metadata.company_code
									        }
								        },
								
							        };
							
							        //console.log('Transaction response :', transaction);
							        //console.log('Transaction Obj', transaction_obj);
							
							        //Payment created tell backend
							
							        ApiDeposit.postDeposit(transaction_obj)
								        .then(response => {
									
									        console.log('Transaction done!!!!', response);
									
									        this.resetCardState();
									        this.props.history.push({
										        pathname: '/profile/wallet', state: {showDepositSuccess: true}
									        });
									
								        })
								        .catch(error => {
									        //console.log(error);
									
									        this.setState({
										        modal: {
											        title: 'Deposit error: Check Value or CVV ...',
											        message: this.getErrorsV2(error),
											        isOpen: true,
										        }
									        });
									
									        this.blockActions(false);
								        })
								        .finally(() => {
									        AuthService.refresh();
								        });
						        } else {
						        	this.setState({
								        modal: {
									        title: 'Deposit error: ',
									        message: 'Opps... Nao foi possivel confirmar o deposito...',
									        isOpen: true,
								        }
								        
							        });
						        	this.blockActions(false);
						        }
			          })
					        .catch(error => {
						        console.log(error);
						        this.setState({
							        modal: {
								        title: 'Deposit error', message: this.getErrorsV2(error), isOpen: true,
							        }
						        });
						        this.blockActions(false);
				        });
			        }
			        else {
		        		console.log('Incluiu cartao ');
				        this.resetCardState();
				        this.props.history.push({
					        pathname: '/profile/creditcards', state: {showDepositSuccess: true}
				        });
			        }
	        })
		        .catch(error => {
	            console.log(error);
	            this.setState({
	              modal: {
	                title: 'Create card error',
	                message: this.getErrorsV2(error),
	                isOpen: true,
	              }
	            });
	            this.blockActions(false);
          });
      })
	      .catch((error) => {
          console.log(error);
          this.setState({
            modal: {
              title: 'Erro nas informacoes do usuario... ',
              message: this.getErrorsV2(error),
              isOpen: true,
            }
          });
          this.blockActions(false);
      });
    }
    catch (error) {
      this.setState({
        modal: {
          title: 'Oops!',
          message: 'Deposit error: Check information. Probably causes: Bad Netword, Value or CVV incorrect...',
          isOpen: true,
        }
      });
    }
    
  };
  
  //#endregion

  render(){
    return (
      <section className="profile-page">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="payment-main">
                <div className="col-md-5 col-xs-12 payment-inner-div">
                  {
                    this.selectedCard ?
                      [
                        <ul className="creditcard-list" >
                          <li className='creditcard-item' key={this.selectedCard.card_id}>
                            <div className="row d-flex align-items-center m-3 p-3">
                              <div className="col-12">
                                <div className="number-card">XXXX-XXXX-XXXX-{this.selectedCard.last_digits}</div>
                                <div className="name-card">{this.selectedCard.holder_name}</div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="offset-8 col">
	                              {this.selectedCard.brand}
                                <img src={this.brands[this.selectedCard.brand]} className="img-card" alt=""/>
                              </div>
                            </div>
                          </li>
                        </ul>
                      ]
                      :
                      [
                        <div className="flags">
                          <img className="col-3" src="/assets/images/bandeira_mastercard_cor.svg" alt=""/>
                          <img className="col-3" src="/assets/images/bandeira_visa_cor.svg" alt=""/>
                          <img className="col-3" src="/assets/images/bandeira_american_cor.svg" alt=""/>
                          <img className="col-3" src="/assets/images/bandeira_elo_cor.svg" alt=""/>
                        </div>
                      ]
                  }
                  <div>
	                
                  </div>
                  {
                    this.selectedCard ?
	                    [
	                    	<div>
			                    <div className="row">
				                    <div className="col-8">
				                      <label className="payment-label">Valor:</label>
			                        <input name="st_amount" type="number" value={ this.state.st_amount } onChange={this.handleElementChange} placeholder="Ex:100" />
				                    </div>
				                    
				                    <div className="col-4">
				                        <label className="payment-label">cvv:</label>
		                            <input name="st_cvv" type="number" value={this.state.st_cvv} onChange={this.handleElementChange} placeholder="000" maxLength="3" />
		                        </div>
			                    </div>
			                    <div className="payment-button-div">
				                    <Link
				                      className="btn btn-pay payment-button-cancel"
				                      to="/profile/creditcards">
				                      Cancel
				                    </Link>
				                    <button disabled={this.state.depositDisabled}
				                            onClick={() => this.doGatewayDeposit(this.payment_gateway, true)}
				                            className="btn-pay payment-button-confirm ">
					                    Confirme Deposito
				                    </button>
				                  </div>
		                    </div>
	                    ]
	                    :
                      [
                        <div>
	                        <div>
	                        
		                        <label className="payment-label">Número Cartão:</label>
	                          <input name="st_card_number" type="text" value={this.state.st_card_number}  onChange={this.handleCardChange} placeholder="Ex: 0000-0000-0000-0000" maxLength="19" />
		                        
		                        <div className="row">
			                        <div className="col-4">
			                          <label className="payment-label">Mes:</label>
			                          <input name="st_expiration_month" type="text" value={this.state.st_expiration_month}  onChange={this.handleElementChange} placeholder="MM" maxLength="2" />
			                        </div>
			                        
			                        <div className="col-4">
				                        <label className="payment-label">Ano:</label>
			                          <input name="st_expiration_year" type="text" value={this.state.st_expiration_year}  onChange={this.handleElementChange} placeholder="AA" maxLength="2" />
			                        </div>
			                        
			                        <div className="col-4">
				                        <label className="payment-label">CVV:</label>
		                            <input name="st_cvv" type="text" value={this.state.st_cvv}  onChange={this.handleElementChange} placeholder="000" maxLength="4" />
			                        </div>
		                        </div>
		                        
		                        <label className="payment-label">Nome:</label>
	                          <input name="st_holder_name" type="text" value={this.state.st_holder_name} onChange={this.handleElementChange} placeholder="Nome do cartao..." maxLength="30" />
	
		                        <label className="payment-label">Primeiro Nome:</label>
	                          <input name="st_first_name" type="text" value={this.state.st_first_name} onChange={this.handleElementChange} placeholder="Primeiro Nome..." maxLength="20" />
	
		                        <label className="payment-label">Sobrenome:</label>
	                          <input name="st_last_name" type="text" value={this.state.st_last_name} onChange={this.handleElementChange} placeholder="Sobrenome..." maxLength="20" />
	
		                        <div className="row">
			                        <div className="col-6">
			                          <label className="payment-label">CPF:</label>
	                            <input name="st_CPF" type="text" value={this.state.st_CPF}  onChange={this.handleElementChange} placeholder="CPF" maxLength="14" />
			                        </div>
			                        
			                        <div className="col-6">
				                        <label className="payment-label">Telefone:</label>
			                          <input name="st_phone_number" type="text" value={this.state.st_phone_number} onChange={this.handleElementChange} placeholder="Somente numeros..." maxLength="14" />
			                        </div>
		                        </div>
		                        
		                        
		                        
		                        {/*
		                        <label className="payment-label">Endereco:</label>
	                          <input name="st_street_address" type="text" value={this.state.street_address} onChange={this.handleElementChange} placeholder="Rua..." maxLength="60" />
		                        
		                        <div className="row">
			                        <div className="col-6">
			                          <label className="payment-label">Bairro:</label>
	                            <input name="st_neiborhood" type="text" value={this.state.st_neiborhood} onChange={this.handleElementChange} placeholder="Bairro" maxLength="60" />
			                        </div>
			                        
			                        <div className="col-6">
				                        <label className="payment-label">Cidade:</label>
			                          <input name="st_city" type="text" value={this.state.st_city} onChange={this.handleElementChange} placeholder="Cidade" maxLength="60" />
			                        </div>
		                        </div>
		                        
		                        <div className="row">
			                        <div className="col-4">
			                          <label className="payment-label">Estado:</label>
			                          <input name="st_state" type="text" value={this.state.st_state} onChange={this.handleElementChange} placeholder="SP" maxLength="2" />
			                        </div>
			                        
			                        <div className="col-4">
				                        <label className="payment-label">Pais:</label>
			                          <input name="st_country" type="text" value={this.state.st_country} onChange={this.handleElementChange} placeholder="BR" maxLength="2" />
			                        </div>
			                        
			                        <div className="col-4">
				                        <label className="payment-label">CEP:</label>
		                            <input name="st_ZIP" type="number" value={this.state.st_ZIP} onChange={this.handleElementChange} placeholder="CEP" maxLength="9" />
			                        </div>
		                        </div> */}
		                      
	                        </div>
	                        
	                        <div className="payment-button-div">
		                       
				                    <Link
				                      className="btn btn-pay payment-button-cancel"
				                      to="/profile/wallet">
				                      Cancel
				                    </Link>
		                      
				                    <button hidden={!this.cardIsValid() }
				                            disabled={this.state.depositDisabled}
				                            onClick={() => this.doGatewayDeposit(this.payment_gateway, false)}
				                            className="btn-pay payment-button-confirm ">
					                    Incluir Cartao
				                    </button>
		                      
				                  </div>
	                        
	                        <div>
			                        
			                        <p> <hr />
				                        Importante: Digite todos números sem espaços ou caracteres especiais e, não utilize recursos de auto preenchimento.
				                        Se todos os dados estiverem corretos aparecerá o botão "Depositar". <hr />
				                        Após o depósito poderá levar alguns minutos para ocorrer o processamento do pagamento.<hr />
				                        Fique tranquilo! caso o valor não apareça em alguns minutos deslogue e logue novamente ou de um refresh no seu navegador.
			                        </p>
			                        
		                        </div>
	                        
	                        
                        </div>
                      ]
                  }
                </div>
              </div>
              <hr />
            </div>
          </div>

          <Loading active={this.state.loading} />
          <MessageModal
            isOpen={this.state.modal.isOpen}
            toggle={this.toggleAlert}
            title={this.state.modal.title}
            message={this.state.modal.message}
          />
        </div>
      </section>
    );
  }
}

export default PaymentPage;





// WEBPACK FOOTER //
// ./src/containers/PaymentPage/index.js